<template>
  <div class="img-wrapper">
    <!-- 处方单打印图片 -->
    <img ref="printImage" :src="prescriptionImg" class="print-img" @load="print" alt />
  </div>
</template>

<script>
/**
 * @file 已废弃 请使用@/components/printImg
 * */
export default {
  name: 'PrintPrescriptionImg',
  props: {
    prescriptionImg: {}
  },
  methods: {
    // 图片load后直接打印
    print() {
      window.print();
    }
  }
};
</script>

<style lang="less" scoped>
.img-wrapper {
  text-align: center;
  padding-top: 25px;
  .print-img {
    height: 750px;
  }
}
</style>
